<template>
  <div class="active-basic">
    <div class="common-form">基本信息</div>

    <el-form-item label="项目标题" prop="task_name" :rules="[{ required: true, message: '请输入项目标题' }]">
      <el-input v-model="form.task_name" placeholder="请输入项目标题" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item label="项目封面图片" prop="image_id" :rules="rulesImage">
      <div class="d-c-c ad-picture" @click="openUpload(1)">
        <img v-if="form.image_id > 0" :src="form.file_path" width="300" height="124" />
        <span v-else class="el-icon-picture-outline"></span>
      </div>
      <p class="ml10 gray">提示：图片尺寸建议330x200</p>
    </el-form-item>
    <el-form-item label="项目背景图片" prop="background_id" :rules="rulesBackground">
      <div class="d-c-c ad-picture" @click="openUpload(2)">
        <img v-if="form.background_id > 0" :src="form.background_path" width="300" height="124" />
        <span v-else class="el-icon-picture-outline"></span>
      </div>
      <p class="ml10 gray">提示：图片尺寸建议750x450</p>
    </el-form-item>
    <el-form-item label="项目类型">
      <el-radio-group v-model="form.task_type">
        <el-radio :label="10">单人项目</el-radio>
        <el-radio :label="20">团体项目</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="是否是健步走" v-if="form.task_type ==10">
      <el-radio-group v-model="form.is_step">
        <el-radio :label="0">否</el-radio>
        <el-radio :label="1">是</el-radio>
      </el-radio-group>
       <div class="tips">健步走活动需要使用微信运动步数打卡记录当天运动情况</div>
    </el-form-item>
    <!-- <el-form-item label="是否投票" v-if="form.task_type ==20">
      <el-radio-group v-model="form.is_vote">
        <el-radio :label="0">否</el-radio>
        <el-radio :label="1">是</el-radio>
      </el-radio-group>
    </el-form-item> -->
    <!-- <el-form-item label="单位" v-if="(!form.is_step && form.task_type ==10) || (!form.is_vote && form.task_type ==20)">
      <el-radio-group v-model="form.unit_type">
        <el-radio :label="1">个</el-radio>
        <el-radio :label="2">秒</el-radio>
      </el-radio-group>
    </el-form-item> -->
    <!-- <el-form-item label="项目完成步数" prop="step_count" v-if="form.is_step && form.task_type ==10">
      <el-input v-model="form.step_count" placeholder="请输入项目完成步数" class="max-w460"></el-input>
    </el-form-item> -->
    <el-form-item label="健步走积分：" v-if="form.is_step && form.task_type ==10">
        <el-button size="small" class="el-icon-circle-plus" @click="AddStep">添加</el-button>
        <table border="0" cellpadding="2" cellspacing="5" class="mt30">
          <tr>
            <th class="tl">打卡步数</th>
            <th class="tl">奖励积分</th>
            <th>操作</th>
          </tr>
          <tr v-for="(item, index) in form.step_points" :key="index">
            <td><el-input size="small" v-model="item.step" placeholder="打卡步数"></el-input></td>
            <td><el-input size="small" v-model="item.points" placeholder="奖励积分"></el-input></td>
            <td><el-button size="small" @click="delStep(index)">删除</el-button></td>
          </tr>
        </table>
      </el-form-item>
    <el-form-item v-else label="项目完成项目积分" prop="points" :rules="[{ required: true, message: '请输入项目完成项目积分' }]">
      <el-input v-model="form.points" placeholder="请输入项目完成项目积分" class="max-w460"></el-input>
    </el-form-item>

    <el-form-item label="项目打卡标题文案" prop="points" v-if="(!form.is_step && form.task_type ==10) || (!form.is_vote && form.task_type ==20)" >
      <el-input v-model="form.title_msg" placeholder="请输入项目打卡标题文案" class="max-w460"></el-input>
      <div class="tips">注释：数量用*代替,不然前端会报错</div>
    </el-form-item>
    <el-form-item label="上传视频提示语" prop="points" v-if="(!form.is_step && form.task_type ==10) || (!form.is_vote && form.task_type ==20)" >
      <el-input v-model="form.video_msg" placeholder="请输入上传视频提示语" class="max-w460"></el-input>
    </el-form-item>

    
    <!--上传图片组件-->
    <Upload v-if="isupload" :isupload="isupload" @returnImgs="returnImgsFunc">上传图片</Upload>
  </div>
</template>

<script>
import Upload from '@/components/file/Upload';
export default {
  components: {
    /*选择商品组件*/
    Upload
  },
  data() {
    /*验证图片是否上传*/
    const validatorImages = (rule, value, callback) => {
      if (value < 1) {
        return callback(new Error('请上传项目图'));
      } else {
        callback();
      }
    };

    const validatorBgImages = (rule, value, callback) => {
      if (value < 1) {
        return callback(new Error('请上传背景图'));
      } else {
        callback();
      }
    };

    return {
      /*是否上传图片*/
      isupload: false,
      type:1,
      /*图片是否上传了*/
      rulesImage: [{ validator: validatorImages, required: true, message: '请上传项目广告图片', trigger: 'change' }],
      rulesBackground:[{ validator: validatorBgImages, required: true, message: '请上传项目背景图片', trigger: 'change' }],
    };
  },
  props: ['form'],
  methods: {
    AddStep(){
        let self = this;
        let data = {'step':0,'points':0};
        self.form.step_points.push(data);
      },
      delStep(key){
        let self = this;
        let step_points = self.form.step_points;
        let newdata = [];
        step_points.forEach((item,index)=>{
          if(index != key){
            newdata.push(item);
          }
        });
        self.form.step_points = newdata;
      },
    /*上传*/
    openUpload(e) {
      this.type = e;
      this.isupload = true;
    },
    /*获取图片*/
    returnImgsFunc(e) {
      if (e != null && e.length > 0) {
        if(this.type == 1){
          this.form.file_path = e[0].file_path;
          this.form.image_id = e[0].file_id;
        }
        if(this.type == 2){
          this.form.background_path = e[0].file_path;
          this.form.background_id = e[0].file_id;
        }
      }
      this.isupload = false;
    }
  }
};
</script>

<style lang="scss">
.active-basic .ad-picture {
  width: 300px;
  height: 124px;
  border-radius: 16px;
  font-size: 40px;
  border: 1px dashed #cccccc;
  color: $blue;
  cursor: pointer;
  overflow: hidden;
}
.active-basic .ad-picture:hover {
  border: 1px dashed $blue;
}

.active-basic .ad-picture img {
  object-fit: fill;
}
</style>



// WEBPACK FOOTER //
// src/views/task/task/part/Basic.vue